const SLUG = {
  SITE_SEARCH: 'search',
}

export default SLUG
